/** @jsx jsx */
import React, { useState } from "react";
import { css, jsx } from "@emotion/core";
import TextForm from "components/molecules/TextForm";
import { RecorderButton, PrimaryButton } from "components/atoms/Button";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { grayScale, customButtonColor } from "components/styles";
import BodyText from "components/atoms/BodyText";
import Modal from "components/molecules/Modal";
import useToastNotification from "hooks/useToastNotification";
import useBarcodeRecorder from "./hooks";
import moment from "moment";
import { isInputEvent } from "formik";
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  formRecorder: css({
    textAlign: "center",
  }),
  dateForm: css({
    width: `${isIpad ? '100%' : '420px'}`,
    justifyContent: 'center',
    margin: "auto",
  }),
  formContainer: css({
    marginTop: "15px",
    borderRadius: "3px",
    paddingBottom: isIpad ? "20px" : "50px",
    display: isIpad ? 'flex' : '',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }),
  imageButton: css({
    width: "100%",
    textAlign: 'center',
    height: '80px',
  }),
  ipadTimeContainer: css({
    display: "flex",
    flexWrap: "wrap",
    alignSelf: "center",
    width: "100%",
    marginLeft: '20px',
    justifyContent: 'center'
  })
};

const inputForm = css`
  width: ${isIpad ? '420px' : '450px'};
  margin: auto;
  justify-content: space-between;
`;

const timeCss = css`
  align-items: baseline;
  justify-content: space-between;
  margin: auto;
  width: ${isIpad ? 'auto' : '350px'};
  color: red;
  line-height: ${isIpad ? '80px' : '100px'};
  span:first-of-type {
    font-size: ${isIpad ? '64px' : '100px'};
    margin-right: 10px;
    font-weight: bold;
    color: ${grayScale.gray100};
  }
  span:last-of-type {
    font-size: 32px;
    color: ${grayScale.gray100};
  }
`;
const btnContainer = css`
  flex-wrap: wrap;
  width: ${isIpad ? '500px' : '700px'};
  justify-content: space-between;
  margin: 30px auto 30px auto;
  height: auto;
  button {
    border-radius: 3px;
    border: 0;
    height: 120px;
    font-size: 24px;
    height: 120px;
    margin-bottom: 20px;
  }
  button:hover {
    opacity: 0.9;
  }
`;

const BarcodeRecorder: React.FC<{
  dataTimes: any;
  dataSettings: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  disabledRecorder: boolean;
  fetchHistoryData: any;
}> = ({
  dataTimes,
  dataSettings,
  setIsLoading,
  disabledRecorder,
  fetchHistoryData,
}) => {
  const { errorNotification } = useToastNotification();
  const [openModal, setOpenModal] = useState(false);
  const {
    handleSubmitBarcode,
    formik,
    formikConfirm,
    isConfirm,
    staffName,
    lastStampType,
    handleRecorder,
    businessName,
    stampType,
    newUiRemote
  } = useBarcodeRecorder(
    dataSettings.stampOrgCode,
    dataSettings.setStampOrgCode,
    dataSettings.stampOrgName,
    dataSettings.setStampOrgName,
    dataSettings.loginOrgCode,
    dataSettings.setLoginOrgCode,
    dataSettings.loginOrgName,
    dataSettings.setLoginOrgName,
    dataTimes.resultCurrentTime,
    setOpenModal,
    setIsLoading,
    fetchHistoryData
  );
  const handleSubmit = () => {
    if (formik.values.inputBarcodeId) {
      handleSubmitBarcode();
    } else {
      errorNotification("打刻IDを入力してください。");
    }
  };
  return (
    <React.Fragment>
      <div css={styles.formContainer}>
        <div css={isIpad ? styles.ipadTimeContainer : {}}>
          {dataTimes.currentDay ? (
            <React.Fragment>
              <FlexBox customStyle={styles.dateForm}>
                <BodyText size="lg" color={grayScale.gray100} bold={true}>
                  {dataTimes.currentDay}
                </BodyText>
              </FlexBox>
              <FlexBox customStyle={timeCss}>
                <BodyText>{dataTimes.timeNow}</BodyText>
                <BodyText>{dataTimes.second}</BodyText>
              </FlexBox>
            </React.Fragment>
          ) : (
            <div
              style={{
                fontSize: isIpad ? '30px' : '80px',
                textAlign: 'center',
                marginBottom: '20px'
              }}
            >
              サーバ時間取得中・・・
            </div>
          )}
        </div>

        {!isConfirm && (
          <FlexBox customStyle={inputForm}>
            <FlexBoxItem basis="270px">
              <TextForm
                name="inputBarcodeId"
                label=""
                value={formik.values.inputBarcodeId}
                onChange={formik.handleChange}
                placeHolder="IDを入力してください"
              />
            </FlexBoxItem>
            <PrimaryButton
              text="IDを入力"
              onClick={() => handleSubmit()}
              disabled={disabledRecorder}
              minWidth={isIpad ? "120px" : "160px"}
              customStyle={css({ fontWeight: "bold" })}
            />
          </FlexBox>
        )}
        {/* {isConfirm && (
          <div style={{ width: "100%", textAlign: "center" }}>
            <BodyText color={grayScale.gray100} size="xxl" bold={true}>
              {staffName}
              {
                (lastStampType === -1 || lastStampType === 3) && "さん、出勤打刻を押してください。"
              }
              {
                (lastStampType === 0 || lastStampType === 2) && "さん、退勤打刻または休憩開始を押してください。"
              }
              {
                lastStampType === 1 && "さん、休憩終了を押してください。"
              }
            </BodyText>
          </div>
        )} */}
        {isConfirm && (
          <React.Fragment>
            <FlexBox customStyle={btnContainer}>
              {(lastStampType === -1 || lastStampType === 3) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="登園"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}

              {/* {(lastStampType === -1 || lastStampType === 3) && !newUiRemote && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="出勤"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}
              {(lastStampType === -1 || lastStampType === 3) && newUiRemote && (
                <React.Fragment>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="オフィス出勤"
                      onClick={() => handleRecorder(0)}
                      icon="checkInOffice"
                      background="#007BC3"
                    />
                  </FlexBoxItem>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="テレワーク出勤"
                      onClick={() => handleRecorder(0, undefined, undefined, true)}
                      icon="checkInRemote"
                      background="#F8BF2D"
                    />
                  </FlexBoxItem>
                </React.Fragment>
              )} */}

              {(lastStampType === 0 || lastStampType === 2) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="退園"
                    onClick={() => handleRecorder(3)}
                    icon="checkOut"
                    background="#666666"
                  />
                </FlexBoxItem>
              )}

              {/* {(lastStampType === 0 || lastStampType === 2) && (
                <RecorderButton
                  text="休憩開始"
                  onClick={() => handleRecorder(1)}
                  icon="breakStart"
                  background="#00B172"
                />
              )}

              {lastStampType === 1 && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="休憩終了"
                    onClick={() => handleRecorder(2)}
                    icon="breakEnd"
                    background="#8B2E9C"
                  />
                </FlexBoxItem>
              )} */}
            </FlexBox>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default BarcodeRecorder;
